import React from 'react';
import Icon from 'utils/components/icon';
import sendFileToServer from '../helpers/send-file-to-server';
import { REACTIONS_SVG_URLS, CUSTOM_REACTION_PREFIX } from '../consts';

const ALLOWED_FORMATS = 'image/png, image/jpeg , image/svg+xml, image/gif';
const MAX_SIZE = 1024 * 100; //maximum file size of a 100Kb.

function isImageAllowed({ size, height, width }) {
  if (size <= MAX_SIZE && height === width) {
    return true;
  }
  return false;
}

function uploadFile(id) {
  document.getElementById(id).click();
}

interface Props {
  reactionId: string;
  title: string | null;
  onCustomImageChange: (newName: string) => void;
  customImageId?: string;
  disabled: boolean;
  spotId: string;
  onErrorStatusChange: (newStatus: boolean) => void;
}

export const ReactionIcon: React.FC<Props> = ({
  reactionId,
  title,
  onCustomImageChange,
  customImageId,
  disabled,
  spotId,
  onErrorStatusChange
}) => {
  const imageUrl = REACTIONS_SVG_URLS[reactionId];

  let customImage = null;
  if (customImageId) {
    customImage = `${CUSTOM_REACTION_PREFIX}/${spotId}/${customImageId}`;
  }

  async function getImageDetails(image) {
    const { width, height, src } = await new Promise(resolve => {
      const img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = function() {
        resolve({
          width: (this as HTMLImageElement).width,
          height: (this as HTMLImageElement).height,
          src: img.src
        });
      };
    });
    return { size: image.size, width, height, src };
  }

  async function onChangeHandler(event) {
    const target = event.target;
    const image = target.files[0];
    if (image) {
      const imageDetails = await getImageDetails(image);
      if (!isImageAllowed(imageDetails)) {
        onErrorStatusChange(true);
        target.value = '';
        return;
      }
      const fileName = await sendFileToServer(spotId, {
        file: image,
        name: reactionId
      });

      onCustomImageChange(fileName.name);
    }
  }

  return (
    <div
      role="button"
      className="reactionIcon"
      onClick={() => {
        onErrorStatusChange(false);
        uploadFile(`${reactionId}-file`);
      }}
      //@ts-ignore
      disabled={disabled}
    >
      <div className={'reactions-modal-camera'}>
        <Icon name="camera-skeleton" className="camera-icon reaction-modal-camera-icon" />
      </div>
      {imageUrl && (
        <img className="reaction-icon-image" src={customImage || imageUrl} alt={title} />
      )}
      <input
        id={`${reactionId}-file`}
        type="file"
        style={{ display: 'none' }}
        onChange={onChangeHandler}
        accept={ALLOWED_FORMATS}
      />
    </div>
  );
};
